import MonitoringReportModeSplitViewModel from "./MonitoringReportModeSplitViewModel";
import MonitoringReportTripGenerationViewModel from "./MonitoringReportTripGenerationViewModel";

export default class MonitoringReportViewModel {
    siteReference: string = '';
    modeSplitTotal: boolean = false;
    vehicleOccupancySplitGraph: boolean = false;
    userDefinedModeSplits1: MonitoringReportModeSplitViewModel = new MonitoringReportModeSplitViewModel();
    userDefinedModeSplits2: MonitoringReportModeSplitViewModel = new MonitoringReportModeSplitViewModel();
    userDefinedModeSplits3: MonitoringReportModeSplitViewModel = new MonitoringReportModeSplitViewModel();
    tripGenerations1: MonitoringReportTripGenerationViewModel = new MonitoringReportTripGenerationViewModel();
    tripGenerations2: MonitoringReportTripGenerationViewModel = new MonitoringReportTripGenerationViewModel();
    tripGenerations3: MonitoringReportTripGenerationViewModel = new MonitoringReportTripGenerationViewModel();
    includedSurveys: string[] = [];
}
